<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->
      <page :url="url" :form="form" @reset="reset">
        <template slot="tableSearch">
          <el-form-item :label="$t('text.operator')">
            <el-input
              v-model="form.orderId"
              :placeholder="$t('message.inputOperator')"
              style="width: 260px"
              maxlength="50"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('text.operationTime')">
            <el-date-picker
              v-model="timeDate"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyyMMdd"
              :range-separator="$t('text.to')"
              :start-placeholder="$t('text.customMessage')"
              :end-placeholder="$t('text.endDate')"
              @change="timeChange"
            >
            </el-date-picker>
          </el-form-item>
        </template>
        <template slot="tableColumn">
          <el-table-column
            prop="createTimeL"
            :label="$t('text.number')"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createTimeL"
            :label="$t('text.operator')"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createTimeL"
            :label="$t('text.operationModule')"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createTimeL"
            :label="$t('text.operationContent')"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createTimeL"
            :label="$t('text.ipAddress')"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createTimeL"
            :label="$t('text.operationTime')"
            align="center"
          ></el-table-column>
        </template>
      </page>
    </div>
  </div>
</template>
<script>
import Page from "@/components/Page.vue";
export default {
  components: {
    page: Page,
  },
  data() {
    return {
      url: "/depositWithdraw/selectList",
      timeDate: [],
      form: {
        orderId: "",
        startDate: "",
        endDate: "",
      },
    };
  },
  methods: {
    timeChange(e) {
      if (e) {
        this.form.startDate = e[0];
        this.form.endDate = e[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
    },
    reset() {
      this.timeDate = [];
    },
  },
};
</script>